import { render, staticRenderFns } from "./DirectIndicator.vue?vue&type=template&id=20a80e77"
import script from "./DirectIndicator.vue?vue&type=script&lang=js"
export * from "./DirectIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports